export default __webpack_public_path__ + "static/media/loading-red.5f820ea3.svg";